import { createAction } from '@reduxjs/toolkit';

export const setItemGroup = createAction('SET_ITEM_GROUP');
export const setItems = createAction('SET_ITEMS');
export const resetItemGroup = createAction('resetItemGroup');
export const resetItems = createAction('resetItems');
export const setSQHistory = createAction('SET_SQ_History');
export const setSOHistory = createAction('SET_SO_History');
export const setHistoryItem = createAction('SET_History_Item');


